import { captureCampaignAttribution } from "@/components/analytics/attribution";
import { useConsentStore } from "@/components/analytics/consent";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

export function AttributionTracker() {
  const searchStr = useLocation({ select: (location) => location.searchStr });
  const consent = useConsentStore((s) => s.consent);

  useEffect(() => {
    // Re-run attribution capture after client-side navigation changes the URL or consent is granted
    void searchStr;
    if (consent === "granted") {
      captureCampaignAttribution();
    }
  }, [searchStr, consent]);

  return null;
}
